export default __webpack_public_path__ + "media/images/paw-icon-19614bcaab3bc1908dc50db99ba6f5bf.svg";